var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-checkbox',{staticClass:"mb-n6 mt-n6",attrs:{"label":_vm.label,"rules":[v => (v || !_vm.required)]},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }